import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20983 18478"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:304.099}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970275637680">
        <path
          d="M4715 1364c0 670 543 1213 1213 1213 669 0 1212-543 1212-1213 0-669-543-1212-1212-1212-670 0-1213 543-1213 1212zM9279 1364c0 670 543 1213 1213 1213 669 0 1212-543 1212-1213 0-669-543-1212-1212-1212-670 0-1213 543-1213 1212z"
          className="fill stroke1"
          style={{
            strokeWidth: 304.099,
          }}
        />
      </g>
      <g id="_1970275638416">
        <path
          d="M4715 5302c0 669 543 1212 1213 1212 669 0 1212-543 1212-1212 0-670-543-1212-1212-1212-670 0-1213 543-1213 1212zM9279 5302c0 669 543 1212 1213 1212 669 0 1212-543 1212-1212 0-670-543-1212-1212-1212-670 0-1213 543-1213 1212zM13842 5302c0 669 543 1212 1213 1212 669 0 1212-543 1212-1212 0-670-543-1212-1212-1212-670 0-1213 543-1213 1212z"
                    className="fill stroke1"
          style={{
            strokeWidth: 304.099,
          }}

        />
      </g>
      <g id="_1970275639696">
        <path
          d="M9279 9239c0 669 543 1213 1213 1213 669 0 1212-544 1212-1213s-543-1213-1212-1213c-670 1-1213 544-1213 1213zM13842 9239c0 669 543 1213 1213 1213 669 0 1212-544 1212-1213s-543-1213-1212-1213c-670 1-1213 544-1213 1213zM18406 9239c0 669 543 1213 1213 1213 669 0 1212-544 1212-1213s-543-1213-1212-1213c-670 1-1213 544-1213 1213z"
                    className="fill stroke1"
          style={{
            strokeWidth: 304.099,
          }}

        />
      </g>
      <g id="_1970275640144">
        <path
          d="M4715 13177c0 669 543 1213 1213 1213 669 0 1212-543 1212-1213 0-669-543-1213-1212-1213-670 0-1213 543-1213 1213zM9279 13177c0 669 543 1213 1213 1213 669 0 1212-543 1212-1213 0-669-543-1213-1212-1213-670 0-1213 543-1213 1213zM13842 13177c0 669 543 1213 1213 1213 669 0 1212-543 1212-1213 0-669-543-1213-1212-1213-670 0-1213 543-1213 1213z"
                    className="fill stroke1"
          style={{
            strokeWidth: 304.099,
          }}

        />
      </g>
      <g id="_1970275642160">
        <path
          d="M4715 17114c0 670 543 1212 1213 1212 669 0 1212-542 1212-1212 0-669-543-1212-1212-1212-670 0-1213 543-1213 1212zM9279 17114c0 670 543 1212 1213 1212 669 0 1212-542 1212-1212 0-669-543-1212-1212-1212-670 0-1213 543-1213 1212z"
                    className="fill stroke1"
          style={{
            strokeWidth: 304.099,
          }}

        />
      </g>
      <path
        id="_1970275644496"
        d="M152 1364c0 670 543 1213 1212 1213 670 0 1213-543 1213-1213 0-669-543-1212-1213-1212-669 0-1212 543-1212 1212z"
                  className="fill stroke1"
          style={{
            strokeWidth: 304.099,
          }}

      />
      <path
        id="_1970275647792"
        d="M152 17114c0 670 543 1212 1212 1212 670 0 1213-542 1213-1212 0-669-543-1212-1213-1212-669 0-1212 543-1212 1212z"
                  className="fill stroke1"
          style={{
            strokeWidth: 304.099,
          }}

      />
    </g>
  </svg>
)
export default SvgComponent
